import lodashFind from 'lodash/find'

export const findByDbId = <T, U extends { _id: T }>(array: U[], id: T): U | undefined =>
    lodashFind(array, (obj) => obj._id === id)
